import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/Icon';

const EXPLORE_LINKS = [
  { icon: '⚡',  label: 'The Trade',           to: '/league-of-record/the-trade' },
  { icon: '👑',  label: 'Commissioner Legacy', to: '/league-of-record/commissioner-legacy' },
  { icon: '🏛️', label: 'Founding Members',    to: '/league-of-record/founding-members' },
  { icon: '📅',  label: 'Milestones',          to: '/league-of-record/milestones' },
];

function EraCard({ era }) {
  const [expanded, setExpanded] = useState(false);
  const {
    icon, year_range, era_subtitle, era_name,
    tone_quote, key_events, description,
  } = era;

  return (
    <div className="lor-lore-era-card lor-card">
      <div className="lor-lore-era-left">
        <div className="lor-lore-era-icon">{icon}</div>
        <div className="lor-lore-era-year">{year_range}</div>
        {era_subtitle && (
          <div className="lor-lore-era-subtitle">{era_subtitle}</div>
        )}
      </div>
      <div className="lor-lore-era-right">
        <div className="lor-lore-era-name">{era_name}</div>
        {tone_quote && (
          <div className="lor-lore-era-quote">"{tone_quote}"</div>
        )}
        {key_events && key_events.length > 0 && (
          <ul className="lor-lore-era-events">
            {key_events.map((event, i) => (
              <li key={i}>{event}</li>
            ))}
          </ul>
        )}
        {description && (
          <>
            <button
              className="lor-lore-expand-btn"
              onClick={() => setExpanded(e => !e)}
            >
              {expanded ? '▲ Less' : '▼ More'}
            </button>
            {expanded && (
              <div className="lor-lore-era-description">{description}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function LORLore({ api }) {
  const [lore, setLore]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const navigate               = useNavigate();

  useEffect(() => {
    fetch(`${api}/api/lor/lore/overview`)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(data => { setLore(data); setLoading(false); })
      .catch(() => { setError('League Lore unavailable.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Loading League Lore…</div>;
  if (error)   return <div className="lor-empty">{error}</div>;

  const eras = lore?.eras || [];

  return (
    <div className="lor-lore-page">
      <div className="lor-page-header">
        <h2 className="lor-page-title">📜 League Lore</h2>
        <div className="lor-page-meta">Pro Analyst · 14 Seasons · One Story</div>
      </div>

      {lore?.intro && (
        <div className="lor-lore-hero lor-card">
          <p className="lor-lore-hero-text">{lore.intro}</p>
        </div>
      )}

      <div className="lor-lore-timeline">
        {eras.length === 0 && (
          <div className="lor-empty">No era data available yet.</div>
        )}
        {eras.map((era, i) => (
          <EraCard key={era.era_name || i} era={era} />
        ))}
      </div>

      <div className="lor-lore-explore lor-card">
        <div className="lor-lore-explore-title">Explore More</div>
        <div className="lor-lore-explore-links">
          {EXPLORE_LINKS.map(link => (
            <button
              key={link.to}
              className="lor-lore-explore-btn"
              onClick={() => navigate(link.to)}
            >
              <Icon emoji={link.icon} size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} /> {link.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
